const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCPTwWkohWDXhstaQ_d4LM5nRw_Iuo1aMY",
  authDomain: "ggo-confessions.firebaseapp.com",
  projectId: "ggo-confessions",
  storageBucket: "ggo-confessions.firebasestorage.app",
  messagingSenderId: "962143688808",
  appId: "1:962143688808:web:071965fe2d5539eab843dd",
  measurementId: "G-Z2T78EH3QZ"
};

const POLL_INTERVAL_MS = 4000;
let _resolveConfLikesReady = null;
let _rejectConfLikesReady = null;
if (!window.confessionsLikesReady) {
  window.confessionsLikesReady = new Promise((resolve, reject) => {
    _resolveConfLikesReady = resolve;
    _rejectConfLikesReady = reject;
  });
}


(function () {

  (async function init() {
    try {
      const [{ initializeApp }, { getAuth, onAuthStateChanged, signInAnonymously }] = await Promise.all([
        import('https://www.gstatic.com/firebasejs/9.22.0/firebase-app.js'),
        import('https://www.gstatic.com/firebasejs/9.22.0/firebase-auth.js')
      ]);

      const app = initializeApp(FIREBASE_CONFIG);
      const auth = getAuth(app);
      async function ensureAuth(timeoutMs = 8000) {
        return new Promise((resolve, reject) => {
          let done = false;

          const unsub = onAuthStateChanged(auth, async (user) => {
            if (user) {
              done = true;
              try { unsub(); } catch(e){}
              resolve(user);
              return;
            }
            try {
              const cred = await signInAnonymously(auth);
              done = true;
              try { unsub(); } catch(e){}
              resolve(cred.user);
            } catch (e) {
              try { unsub(); } catch(e){}
              reject(e);
            }
          });

          setTimeout(() => {
            if (!done) {
              try { unsub(); } catch(e){}
              reject(new Error('auth_timeout'));
            }
          }, timeoutMs);
        });
      }

      async function getIdToken(force = false){
        if (!auth.currentUser) {
          try { await signInAnonymously(auth); }
          catch(e){ throw e; }
        }
        return auth.currentUser.getIdToken(force);
      }
      function qs(sel){ return Array.from(document.querySelectorAll(sel)); }

      function docPath(id){
        return `projects/${FIREBASE_CONFIG.projectId}/databases/(default)/documents/likes/${String(id)}`;
      }

      function userLikeDocPath(id, uid){
        return `projects/${FIREBASE_CONFIG.projectId}/databases/(default)/documents/likes/${String(id)}/userLikes/${String(uid)}`;
      }

      async function restGetLikes(articleId){
        try {
          const idToken = await getIdToken(false);
          const url = `https://firestore.googleapis.com/v1/${docPath(articleId)}?mask.fieldPaths=likes`;
          const res = await fetch(url, {
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + idToken }
          });
          if (!res.ok) {
            if (res.status === 404) return { ok:true, likes:0 };
            return { ok:false };
          }
          const json = await res.json();
          const likes = json.fields && json.fields.likes
            ? Number(json.fields.likes.integerValue || json.fields.likes.doubleValue || 0)
            : 0;
          return { ok:true, likes };
        } catch(e){
          return { ok:false };
        }
      }

      async function restLikeArticle(articleId){
        try {
          const idToken = await getIdToken(true);
          const uid = auth.currentUser && auth.currentUser.uid ? auth.currentUser.uid : null;
          if (!uid) throw new Error('no-auth-uid');

          const writes = [
            {
              transform: {
                document: docPath(articleId),
                fieldTransforms: [
                  { fieldPath:'likes', increment:{ integerValue:'1' } }
                ]
              }
            },
            {
              update: {
                name: userLikeDocPath(articleId, uid),
                fields: { createdAt:{ timestampValue:new Date().toISOString() } }
              },
              currentDocument:{ exists:false }
            }
          ];

          const commitUrl = `https://firestore.googleapis.com/v1/projects/${FIREBASE_CONFIG.projectId}/databases/(default)/documents:commit`;
          const commitRes = await fetch(commitUrl, {
            method:'POST',
            headers:{ 'Authorization':'Bearer ' + idToken, 'Content-Type':'application/json' },
            body: JSON.stringify({ writes })
          });

          if (!commitRes.ok) {
            const txt = await commitRes.text();
            if (/already exists|failed_precondition|precondition|constraint/i.test(txt)) {
              return { success:false, alreadyLiked:true };
            }
            return { success:false };
          }

          const text = await commitRes.text();
          const parsed = text ? JSON.parse(text) : null;

          let newCount = null;
          if (parsed && parsed.writeResults && parsed.writeResults.length > 0) {
            const tr = parsed.writeResults[0].transformResults;
            if (tr && tr.length > 0) {
              if (tr[0].integerValue) newCount = Number(tr[0].integerValue);
              if (tr[0].doubleValue) newCount = Number(tr[0].doubleValue);
            }
          }

          if (newCount === null) {
            const getRes = await restGetLikes(articleId);
            if (getRes.ok) newCount = getRes.likes;
          }

          return { success:true, likes:newCount };
        } catch(e){
          return { success:false };
        }
      }
      async function fetchAllArticleLikes(){
        const buttons = qs('.like-button[data-article-id]');
        const ids = [...new Set(buttons.map(b => b.getAttribute('data-article-id')).filter(Boolean))];
        if (!ids.length) return;

        const results = await Promise.all(ids.map(id => restGetLikes(id)));

        results.forEach((r, i) => {
          const id = ids[i];
          const el = document.querySelector(`.like-count[data-article-id="${id}"]`);
          if (!el) return;
          if (r.ok) el.textContent = String(r.likes);
          else el.textContent = '—';
        });
      }
      async function fetchLikesForIds(ids = []) {
        const map = {};
        if (!ids.length) return map;
        try {
          const token = await getIdToken(false);
          const calls = ids.map(id => {
            const url = `https://firestore.googleapis.com/v1/${docPath(id)}?mask.fieldPaths=likes`;
            return fetch(url, { method:'GET', headers:{ Authorization:'Bearer ' + token }}).then(async res => {
              if (!res.ok) {
                if (res.status === 404) { return { id, likes:0 }; }
                return { id, likes:null };
              }
              const json = await res.json();
              const likes = json.fields && json.fields.likes
                ? Number(json.fields.likes.integerValue || json.fields.likes.doubleValue || 0)
                : 0;
              return { id, likes };
            }).catch(() => ({ id, likes:null }));
          });

          const results = await Promise.all(calls);
          results.forEach(r => {
            map[r.id] = (r.likes === null || r.likes === undefined) ? 0 : Number(r.likes);
          });
        } catch(e) {
          console.warn('fetchLikesForIds failed', e);
          ids.forEach(id => map[id] = 0);
        }
        return map;
      }

      // Filter UI + ordering logic 

      function $q(sel){ return document.querySelector(sel); }
      function $qa(sel){ return Array.from(document.querySelectorAll(sel)); }
      function ensureFilterUI() {
        let filter = $q('.conf-filter');
        if (filter) return filter;
        const container = $q('.confessions-container') || $q('.confessions-grid');
        if (!container) return null;
        const wrap = document.createElement('div');
        wrap.className = 'conf-filter-wrap';
        wrap.innerHTML = `
          <div class="conf-filter" role="tablist" aria-label="Sort confessions">
            <button class="conf-filter-btn" data-sort="latest" role="tab" aria-selected="true">Latest</button>
            <button class="conf-filter-btn" data-sort="popular" role="tab" aria-selected="false">Popular</button>
          </div>
        `;
        container.parentNode.insertBefore(wrap, container);
        return $q('.conf-filter');
      }
      const grid = $q('.confessions-grid');
      const originalOrder = grid ? Array.from(grid.children) : [];

      function collectItems() {
        if (!grid) return [];
        return Array.from(grid.querySelectorAll('.confession-item')).map((el, idx) => {
          const btn = el.querySelector('.like-button[data-article-id]');
          const id = btn ? btn.getAttribute('data-article-id') : null;
          return { el, id, originalIndex: idx };
        }).filter(x => x.id !== null);
      }

      function applyLatestUIState() {
        $qa('.conf-filter-btn').forEach(btn => {
          const is = btn.getAttribute('data-sort') === 'latest';
          btn.setAttribute('aria-selected', String(is));
        });
      }

      function applyPopularUIState() {
        $qa('.conf-filter-btn').forEach(btn => {
          const is = btn.getAttribute('data-sort') === 'popular';
          btn.setAttribute('aria-selected', String(is));
        });
      }

      function applyLatest() {
        if (!grid) return;
        const frag = document.createDocumentFragment();
        originalOrder.forEach(node => {
          if (node) frag.appendChild(node);
        });
        grid.appendChild(frag);
        applyLatestUIState();
        localStorage.setItem('conf_sort', 'latest');
      }

      async function applyPopular() {
        if (!grid) return;
        const items = collectItems();
        const ids = items.map(i => i.id);
        $qa('.conf-filter-btn').forEach(b => b.disabled = true);
        try {
          const likesMap = await fetchLikesForIds(ids);
          items.forEach(it => {
            const elc = it.el.querySelector(`.like-count[data-article-id="${it.id}"]`);
            if (elc && likesMap[it.id] !== undefined) elc.textContent = String(likesMap[it.id]);
          });
          items.sort((a,b) => {
            const la = (likesMap[a.id] !== undefined) ? likesMap[a.id] : 0;
            const lb = (likesMap[b.id] !== undefined) ? likesMap[b.id] : 0;
            if (lb !== la) return lb - la;
            return a.originalIndex - b.originalIndex;
          });
          const frag = document.createDocumentFragment();
          items.forEach(it => frag.appendChild(it.el));
          grid.appendChild(frag);
          applyPopularUIState();
          localStorage.setItem('conf_sort', 'popular');
        } catch(e) {
          console.warn('applyPopular failed', e);
        } finally {
          $qa('.conf-filter-btn').forEach(b => b.disabled = false);
        }
      }

      async function wire(){
        let user;
        try { user = await ensureAuth(); }
        catch(e){
          alert('Auth failed: likes will not work');
          if (typeof _resolveConfLikesReady === 'function') try { _resolveConfLikesReady(); } catch(e){}
          return;
        }
        try {
          await fetchAllArticleLikes();
          if (typeof _resolveConfLikesReady === 'function') try { _resolveConfLikesReady(); } catch(e){}
        } catch(e) {
          if (typeof _resolveConfLikesReady === 'function') try { _resolveConfLikesReady(); } catch(e){}
        }
        setInterval(fetchAllArticleLikes, POLL_INTERVAL_MS);
        const LOCAL_KEY = 'conf_likes_vdiag';

        let localObj = {};
        try { localObj = JSON.parse(localStorage.getItem(LOCAL_KEY) || '{}'); }
        catch(e){ localObj = {}; }

        const buttons = qs('.like-button[data-article-id]');
        buttons.forEach(btn => {

          const id = btn.getAttribute('data-article-id');
          if (localObj[id]) btn.classList.add('is-liked');

          btn.addEventListener('click', async (ev) => {
            ev.preventDefault();

            let stored = {};
            try { stored = JSON.parse(localStorage.getItem(LOCAL_KEY) || '{}'); }
            catch(e){ stored = {}; }

            if (stored[id]) {
              btn.classList.add('is-liked');
              return;
            }

            if (btn.classList.contains('is-liking')) return;
            btn.classList.add('is-liking');

            const res = await restLikeArticle(id);

            if (!res.success) {
              if (res.alreadyLiked) {
                try {
                  const obj = JSON.parse(localStorage.getItem(LOCAL_KEY) || '{}');
                  obj[id] = Date.now();
                  localStorage.setItem(LOCAL_KEY, JSON.stringify(obj));
                } catch(e){}

                btn.classList.remove('is-liking');
                btn.classList.add('is-liked');

                const elc = document.querySelector(`.like-count[data-article-id="${id}"]`);
                if (elc) elc.textContent = elc.textContent === '—' ? '1' : elc.textContent;

              } else {
                btn.classList.remove('is-liking');
                btn.classList.remove('is-liked');
                alert('Could not register like. Try again.');
              }
            } else {
              try {
                const obj = JSON.parse(localStorage.getItem(LOCAL_KEY) || '{}');
                obj[id] = Date.now();
                localStorage.setItem(LOCAL_KEY, JSON.stringify(obj));
              } catch(e){}

              btn.classList.remove('is-liking');
              btn.classList.add('is-liked');

              const elc = document.querySelector(`.like-count[data-article-id="${id}"]`);
              if (elc && res.likes !== null && res.likes !== undefined) {
                elc.textContent = String(res.likes);
              }
            }
          });
        });

        const filterEl = ensureFilterUI();
        if (filterEl) {
          filterEl.addEventListener('click', function(e){
            const btn = e.target.closest('.conf-filter-btn');
            if (!btn) return;
            const sort = btn.getAttribute('data-sort');
            if (sort === 'latest') applyLatest();
            else if (sort === 'popular') applyPopular();
          });
          filterEl.addEventListener('keydown', function(e){
            const key = e.key;
            if (!['ArrowLeft','ArrowRight','Home','End'].includes(key)) return;
            e.preventDefault();
            const btns = $qa('.conf-filter-btn');
            const activeIndex = btns.findIndex(b => b.getAttribute('aria-selected') === 'true');
            let nextIndex = activeIndex;
            if (key === 'ArrowLeft') nextIndex = Math.max(0, activeIndex - 1);
            if (key === 'ArrowRight') nextIndex = Math.min(btns.length - 1, activeIndex + 1);
            if (key === 'Home') nextIndex = 0;
            if (key === 'End') nextIndex = btns.length - 1;
            btns[nextIndex].focus();
            btns[nextIndex].click();
          });
          const saved = localStorage.getItem('conf_sort') || 'latest';
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', wire);
      } else {
        wire();
      }

    } catch(e){
      alert('Confessions like init failed.');
    }

  })();

})();